import axios from "axios";
import { useState } from "react";
import { useMessage, useAuth } from "../../../../global-components/src";
import { EyeOff, Eye } from "react-feather";
import { PACOCA_API_URL } from "../../../../global-components/src/utils/vars";
import { useTranslation } from "react-i18next";

interface Props {
    id_user: number;
    is_muted: boolean;
}

const MuteUser: React.FC<Props> = ({ id_user, is_muted }) => {
    const [isMuted, setIsMuted] = useState(is_muted ?? false);
    const { setMessage } = useMessage();
    const { isAuthenticated, token, user: authUser } = useAuth();
    const { t } = useTranslation();

    const handleMuteUser = async () => {
        const url = `${PACOCA_API_URL}/users/${isMuted ? "unmute" : "mute"}/${id_user}`;

        try {
            await axios.post(url, { muted_user_id: id_user }, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            setIsMuted(!isMuted);
            setMessage(!isMuted ? t("post.userMuted") : t("post.userUnmuted"), "success");
        } catch (err: any) {
            console.error(err);

            if (err.response) {
                setMessage(err.response.data?.message || t("generics.error"), "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage(t("generics.error"), "error");
            }

            if (err.status === 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status === 401)
                setMessage(t("generics.errors.sessionExpired"), "error");
        }
    };

    return (
        <>
            {isAuthenticated && id_user !== authUser?.id ? (
                <li>
                    <ul className="ul-normal">
                        <span className="dropdown-item cursor-pointer user-select-none" onClick={handleMuteUser}>
                            <div className="div-icon-fix">
                                {!isMuted ? (
                                    <><EyeOff data-feather="eye-off" className="icon-config-post" /> {t("post.actions.muteUser")}</>
                                ) : (
                                    <><Eye data-feather="eye" className="icon-config-post" /> {t("post.actions.unmuteUser")}</>
                                )}
                            </div>
                        </span>
                    </ul>
                </li>
            ) : null}
        </>
    );
};

export default MuteUser;
